import { Box, ListItem } from '@mui/material'
import { alpha } from '@mui/material/styles'
import useInnovaTheme from 'components/common/hooks/useInnovaTheme'

const HeaderRow = ({ row, style }) => {
  const { theme, getTextColor } = useInnovaTheme()

  return (
    <ListItem disableGutters style={style} sx={{ px: 1, py: 1 }}>
      <Box
        sx={{
          width: '100%',
          px: 2,
          py: 1,
          borderRadius: 1,

          display: 'flex',
          alignItems: 'center',

          background: alpha(getTextColor(), theme === 'dark' ? 0.14 : 0.08),

          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 1.2,
          textTransform: 'uppercase',

          color: alpha(getTextColor(), 0.85),
        }}>
        {row.operator}
      </Box>
    </ListItem>
  )
}

export default HeaderRow
